'use client';

import { createContext } from 'react';

import type { WithID } from '@ps/models/lib/base';
import type { PrivateProfile } from '@ps/models/lib/private-profile';
import type { Profile } from '@ps/models/lib/profile';
import type { ReadonlyProfile } from '@ps/models/lib/readonly-profile';
import { BehaviorSubject } from 'rxjs';

export type UserProfileContextValue = {
  currentUserProfile$: BehaviorSubject<WithID<Profile> | undefined>;
  currentUserProfile: WithID<Profile> | undefined;
  currentUserPrivateProfile$: BehaviorSubject<
    WithID<PrivateProfile> | undefined
  >;
  currentUserPrivateProfile: WithID<PrivateProfile> | undefined;
  currentUserReadonlyProfile$: BehaviorSubject<
    WithID<ReadonlyProfile> | undefined
  >;
  currentUserReadonlyProfile: WithID<ReadonlyProfile> | undefined;
};

export const UserProfileContext = createContext<UserProfileContextValue | null>(
  null,
);
